/* 招标模块路由 */
// import Main from '@/view/main'
export default {
  path: 'tender',
  meta: {
    title: '招投标管理'
  },
  component: () => import('@/components/parent-view'),
  name: 'tender',
  children: [
    {
      path: 'category',
      name: 'tender-category',
      meta: {
        title: '分类管理'
      },
      component: () => import('@/view/tender/category')
    },
    {
      path: 'support',
      name: 'tender-support',
      meta: {
        title: '服务支持'
      },
      component: () => import('@/view/tender/support')
    },
    {
      path: 'audit',
      name: 'tender-audit',
      meta: {
        title: '标书审核'
      },
      component: () => import('@/view/tender/audit')
    },
    {
      path: 'audit/detail',
      name: 'tender-detail',
      meta: {
        title: '标书审核详情',
        hideInTabBar: true
      },
      component: () => import('@/view/tender/audit/detail.vue')
    },
    {
      path: 'query',
      meta: {
        title: '标书查询',
        ignoreBreadCrumb: true
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          name: 'tender-query',
          meta: {
            title: '标书查询'
          },
          component: () => import('@/view/tender/query/index.vue')
        },
        {
          path: 'auditDetail',
          meta: {
            title: '标书审核详情',
            hideInTabBar: true
          },
          component: () => import('@/view/tender/audit/detail.vue')
        },
        {
          path: 'detail/:id',
          name: 'tender-query-detail',
          meta: {
            title: '投标详情',
            hideInTabBar: true
          },
          component: () => import('@/view/tender/query/detail.vue')
        },
        {
          path: 'add/:id',
          name: 'tender-query-add',
          meta: {
            title: '添加投标单位',
            hideInTabBar: true
          },
          component: () => import('@/view/tender/query/add.vue')
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/tender.js